import { createRouter, createWebHashHistory } from 'vue-router'


import authRoutes from '@/views/auth/authRoutes';
import accessRoutes from '@/views/access/accessRoutes';
import dashboardRoutes from '@/views/dashboardRoutes';
import settingsRoutes from '@/views/settings/settingsRoutes';
import auditLogsRoutes from '@/views/logs/auditLogsRoutes';
import locationRoutes from '@/views/location/locationRoutes';
import subscriptionRoutes from '@/views/subscription/subscriptionRoutes';
import usersRoutes from '@/views/users/usersRoutes';
import clientsRoutes from '@/views/clients/clientsRoutes';
import crudRoutes from '@/views/crud/crudRoutes';



import LoginLayout from '../layouts/LoginLayout.vue'
import AdminLayout from '../layouts/AdminLayout.vue'

import Login from '../views/auth/views/Login.vue'
import Register from '../views/auth/views/Register.vue'
//import Dashboard from '../views/Dashboard.vue'

const routes = [
   
  {
    path: '/',
    component: LoginLayout,
    children: [
      { path: 'login/', component: Login },
      { path: 'register/', component: Register },
      ...authRoutes
    ]
  },

  {
    path: '/admin',
    component: AdminLayout,
    children: [
      //{ path: '/dashboard/', component: Dashboard },
      ...accessRoutes,
      ...dashboardRoutes,
      ...settingsRoutes,
      ...auditLogsRoutes,
      ...locationRoutes,
      ...subscriptionRoutes,
      ...usersRoutes,
      ...crudRoutes,
      ...clientsRoutes
    ]
  }

]


const router = createRouter({
  history: createWebHashHistory(),
  routes
});

//Check if user is logged in. If not redirect to log in page
router.beforeEach((to, from, next) => {
  const loggedInStatus = localStorage.getItem('loggedIn');
  const roles = JSON.parse(localStorage.getItem('roles')) || [];
  const permissions = JSON.parse(localStorage.getItem('permissions')) || [];
  const subscription_permissions = JSON.parse(localStorage.getItem('subscription_permissions')) || [];
  
  //Begin authentication
  // Define public routes that do not require authentication
  const publicRoutes = [
    '/', '/register/','/forgot-password/',
    '/mfa-send-code/','/mfa-verify-code/',
    '/reset-password/'
    ];
  const isLoggedIn = loggedInStatus === 'true';
  if (loggedInStatus === 'true') {
    //$('#navibar').show();

    // If user is logged in and trying to access public routes (login, register etc)
    if (isLoggedIn && publicRoutes.includes(to.path)) {
       return next('/dashboard/'); // or next(from.fullPath) if you prefer return to previous
    }

    // Permission & Subscription checks for protected routes and Billable routes
    // 1. Role first: a user whose role can't use the page gets Access Denied (an upgrade wouldn't help)
    if (to.meta.requiresPermission && !permissions.includes(to.meta.requiresPermission)) {
      return next('/access-denied/');
    }
    // 2. Then the package: send to My Subscription, saying which feature they tried to open
    if (to.meta.requiresSubscription && !subscription_permissions.includes(to.meta.requiresSubscription)) {
      return next({
        path: '/profile/my_subscription/',
        query: { feature: to.meta.featureName || to.meta.requiresSubscription }
      });
    }
    //End Permission & Subscription checks for protected routes and Billable routes

    if (publicRoutes.includes(to.path)) {

    } else {
    next(); // Allow navigation      
    }
  } else {
    if (publicRoutes.includes(to.path)) {
      next(); // Allow access to login & register pages
    } else {
      next('/'); // Redirect to login page
      //$('#navibar').hide();
    }
  }
});
//End Check if user is logged in. If not redirect to log in page
//End authentication


export default router

/*export default createRouter({
  history: createWebHistory(),
  routes
})*/
